/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/href-no-hash */
import React from 'react';
import { NavLink } from 'react-router-dom';

// For the sake of the demo, not creating more components for purely displaying markup.
const DashboardContainer = () => (
  <div>
    <div className="page-title">
      <h1>Create New Contract</h1>
    </div>
    <p className="simulation">
      The Beta is currently in Simulation Mode. It does not interact with the Blockchain and you are
      not being charged fees.
    </p>
    <div className="contract-view-row">
      <NavLink className="custom-app-bar contract-view" to="/contract/new">
        <strong>ERC20 Token</strong>
        <br />
        Release a new token on the Ethereum blockchain.
      </NavLink>
      <a className="custom-app-bar contract-view inactive" href="#">
        <strong>Token Sale</strong>
        <br />
        Design, schedule and launch your own token sale.
      </a>

      <a className="custom-app-bar contract-view inactive" href="#">
        <strong>Airdrop</strong>
        <br />
        Schedule a mass distribution of tokens.
      </a>
    </div>
    <div className="contract-view-row">
      <a className="custom-app-bar contract-view inactive" href="#">
        <strong>Joint Payments</strong>
        <br />
        Create a payment which can be funded by multiple users.
      </a>

      <a className="custom-app-bar contract-view inactive" href="#">
        <strong>Wallet Automation</strong>
        <br />
        Automate the transfer of funds between wallets.
      </a>

      <a className="custom-app-bar contract-view inactive" href="#">
        <strong>Timelock Vault</strong>
        <br />
        Lock up Ether or tokens until a condition is met.
      </a>
    </div>
  </div>
);

export default DashboardContainer;



// WEBPACK FOOTER //
// ./src/containers/DashboardContainer.js